"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var paper_1 = __importDefault(require("../../paper"));
var utils_1 = require("../../../utils");
var paddingTop = 12;
var useStyles = utils_1.makeStyles(function (theme) { return ({
    container: {
        height: '100vh'
    },
    title: {
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2),
        textAlign: 'center'
    },
    leftContainer: {
        backgroundColor: theme.palette.background.paper,
        paddingTop: theme.spacing(paddingTop)
    },
    leftContent: {
        boxShadow: 'none',
        borderRadius: 0
    },
    rightContainer: {
        backgroundColor: theme.palette.primary.main,
        paddingLeft: theme.spacing(12),
        paddingTop: theme.spacing(paddingTop)
    },
    defaultContainer: {
        backgroundColor: theme.palette.primary.main,
        minHeight: '100vh'
    },
    defaultTitle: {
        color: theme.palette.primary.contrastText,
        marginBottom: theme.spacing(2),
        textAlign: 'center'
    }
}); });
var LoginLayout = function (_a) {
    var children = _a.children, title = _a.title, _b = _a.layout, layout = _b === void 0 ? 'default' : _b, otherContent = _a.otherContent, backgroundImage = _a.backgroundImage;
    var classes = useStyles();
    var getBgImage = function () {
        if (backgroundImage) {
            return "url(" + backgroundImage + ")";
        }
        return '';
    };
    var bgStyles = {
        backgroundImage: getBgImage(),
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundBlendMode: 'multiply'
    };
    if (layout === 'default') {
        return (react_1["default"].createElement(core_1.Grid, { container: true, spacing: 0, direction: "column", alignItems: "center", justify: "center", className: classes.defaultContainer, style: bgStyles },
            react_1["default"].createElement(core_1.Grid, { item: true, xs: 12 },
                react_1["default"].createElement(core_1.Typography, { className: classes.defaultTitle, component: "h1", variant: "h4" }, title),
                react_1["default"].createElement(paper_1["default"], null, children))));
    }
    return (react_1["default"].createElement(core_1.Grid, { container: true, className: classes.container, direction: layout === 'right' ? 'row-reverse' : 'row' },
        react_1["default"].createElement(core_1.Grid, { item: true, xs: 12, md: 4, className: classes.leftContainer },
            react_1["default"].createElement(core_1.Typography, { className: classes.title, component: "h1", variant: "h4" }, title),
            react_1["default"].createElement(paper_1["default"], { className: classes.leftContent }, children)),
        react_1["default"].createElement(core_1.Grid, { item: true, xs: 12, md: 8, className: classes.rightContainer, style: bgStyles }, otherContent || null)));
};
exports["default"] = LoginLayout;
